export default __webpack_public_path__ + "static/media/012-igloo.ccf3331e.svg";